var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_COUNTRIES = 'api/country';
const REQUEST_PARAMS = {
    token: 'LOGGED_USER_TOKEN',
};
export const getCountries = function () {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: '' }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_COUNTRIES}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getCountries:', error);
            throw error;
        }
    });
};
